export default function DeleteAccount() {
  return (
    <div className="bg-white text-slate-900">
      <div className="mx-auto max-w-4xl px-4 py-10 lg:py-16">
        <h1 className="text-3xl font-bold text-slate-900">Delete Your Happy Tail Tracker Account</h1>
        <p className="mt-2 text-sm text-slate-600">
          You can request deletion of your account and associated data at any time. Follow the steps below or contact us
          if you need help.
        </p>

        <section className="mt-8 space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">How to request deletion</h2>
          <ol className="list-decimal space-y-2 pl-6 text-slate-800">
            <li>Open Happy Tail Tracker on your device and sign in.</li>
            <li>Go to <strong>Profile</strong> &gt; <strong>Danger zone</strong>.</li>
            <li>Select <strong>Deactivate account</strong> and confirm.</li>
          </ol>
          <p className="text-slate-800">
            If you cannot access the app, email <a href="mailto:support@happytailtracker.com" className="text-blue-600 underline">support@happytailtracker.com</a> from
            the address tied to your account and we will process the request manually.
          </p>
        </section>

        <section className="mt-8 space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">What we delete</h2>
          <ul className="list-disc space-y-2 pl-6 text-slate-800">
            <li>Your account and authentication records.</li>
            <li>All pet profiles, notes, medications, conditions, vaccinations, foods, and attachments you added.</li>
            <li>Shared links and tokens generated for pet summaries.</li>
          </ul>
          <p className="text-slate-800">
            Deletion removes data from active systems immediately. Backups are overwritten on their normal cycle; once
            backups expire, deleted data cannot be restored.
          </p>
        </section>

        <section className="mt-8 space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">What we may retain</h2>
          <ul className="list-disc space-y-2 pl-6 text-slate-800">
            <li>Minimal logs needed for security, fraud prevention, or legal compliance.</li>
            <li>Receipts or billing records we are required to keep for tax and accounting purposes.</li>
          </ul>
          <p className="text-slate-800">
            These retained records do not include your pet profiles, notes, or photos.
          </p>
        </section>

        <section className="mt-8 space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">Export before you delete</h2>
          <p className="text-slate-800">
            You can export all of your pet data and attached images before deactivating. Open Happy Tail Tracker,
            navigate to <strong>Profile</strong>, choose <strong>Export data</strong>, and follow the prompts to save a zip file.
            Doing this before deletion lets you keep a personal copy of your records.
          </p>
        </section>

        <section className="mt-8 space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">Need help?</h2>
          <p className="text-slate-800">
            Contact <a href="mailto:support@happytailtracker.com" className="text-blue-600 underline">support@happytailtracker.com</a> with the email tied to your account and a brief
            note that you want your data deleted. We typically complete requests within a few business days.
          </p>
        </section>
      </div>
    </div>
  );
}
